import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { Component } from "react";
import Title from "../GenericComponents/Title";
import swal from "sweetalert";
import { post_ApiManager } from "../ApiManager/ApiManager";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import { useNavigate } from "react-router-dom";
import { agent_type } from "../../utilis/appStatus";
import { isValidPhoneNumber } from "react-phone-number-input";
import CustomPhoneInput from "./InputField";

export const withNavigation = (Component: Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};

class AddAgent extends Component {
  constructor(props) {
    super(props);
    var permissions = getPermissions();
    this.state = {
      agentNameError: null,
      agencyNameError: null,
      emailError: null,
      phoneError: null,
      countryCodeError: null,
      typeError: null,
      managerError: null,
      agentName: "",
      agencyName: "",
      email: "",
      phone: "",
      type: "",
      defaultCountry: "AU",
      description: "",
      allPermissions: permissions,
      manager: "",
      userList: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
  }

  componentDidMount() {
    this.fetchUsersForAssigned();
  }

  fetchUsersForAssigned = async () => {
    try {
      const response = await apiUrl.get("/fetchUsersForAssigned");
      const users = response?.data?.data?.users || [];
      this.setState({ userList: users });
    } catch (error) {
      console.error("Error fetching users:", error);
      this.setState({ userList: [] });
    }
  };

  handleValidation = (e) => {
    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    this.setState({
      agentNameError: null,
      emailError: null,
      phoneError: null,
      agencyNameError: null,
      managerError: null,
    });
    if (!isValidPhoneNumber(this.state.phone)) {
      this.setState({ phoneError: "Invalid Phone Number" });
      return false;
    }
    if (!this.state.agentName) {
      this.setState({ agentNameError: "Please enter agent name" });
      return false;
    }
    if (!this.state.agencyName) {
      this.setState({ agencyNameError: "Please enter agency " });
      return false;
    }
    if (!this.state.type) {
      this.setState({ typeError: "Please select type" });
      return false;
    }
    if (!this.state.email) {
      this.setState({ emailError: "Please enter email" });
      return false;
    }
    if (!pattern.test(this.state.email)) {
      this.setState({ emailError: "Please enter correct email" });
      return false;
    }
    if (!this.state.phone) {
      this.setState({ phoneError: "Please enter phone" });
      return false;
    } else return true;
  };

  //set input values
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  //   when phone number is changed in input field
  handlePhoneChange(phone) {
    this.setState({ phone });
  }
  //submit form
  handleSubmit(event) {
    event.preventDefault();
    if (this.handleValidation()) {
      const fetchUser = JSON.parse(localStorage.getItem("user"));
      const handlingManagerId = this.state.manager || fetchUser?.id;

      const data = {
        agentname: this.state.agentName,
        agencyname: this.state.agencyName,
        contact: this.state.phone,
        email: this.state.email,
        description: this.state.description,
        type: this.state.type,
        handling_manager: handlingManagerId,
      };
      this.setState({ loading: true });
      let url = "agents";
      post_ApiManager(
        data,
        url,
        (res) => {
          this.setState({ loading: false });
          if (res.data.error) swal(" ", res.data.error, "error");
          else {
            swal("Success!", "New agent created successfully!", "success");
            this.props.navigate("/agents/view-agents");
          }
        },
        (err) => {
          this.setState({ loading: false });
          console.log(err);
        }
      );
    }
  }
  render() {
    return (
      <>
        <Title title="Add Agent"></Title>
        {this.state.allPermissions["agents"] === 1 ? (
          <div className="pt-0 pl-lg-3 pr-lg-3 pl-3 pr-4">
            <div className="row j-content-center mx-3">
              <div className="col-lg-12 bordered scroll mb-5 mb-lg-1 ">
                <div className="text-center pb-2 pt-3 bg-green">
                  <h4 className="subtitle">Add Agent</h4>
                </div>
                <form action="" onSubmit={this.handleSubmit}>
                  <div className="row bg-white p-4 pt-2 pb-0 ">
                    <div className="col-lg-4 pl-lg-3 ">
                      <div className="form-group ">
                        <label className="acc-label2 mb-1">Agent Name*</label>
                        <input
                          type="text"
                          name="agentName"
                          value={this.state.agentName}
                          onChange={this.handleChange}
                          className="form-control acc-form w-lg-90"
                          placeholder="Please Enter"
                        />
                        {this.state.agentNameError && (
                          <>
                            <small className="error">
                              {this.state.agentNameError}
                            </small>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label className="acc-label2 mb-1">Agency Name*</label>
                        <input
                          type="text"
                          name="agencyName"
                          value={this.state.agencyName}
                          onChange={this.handleChange}
                          className="form-control acc-form w-lg-90"
                          placeholder="Please Enter"
                        />
                        {this.state.agencyNameError && (
                          <>
                            <small className="error">
                              {this.state.agencyNameError}
                            </small>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 pt-0">
                      <div className="form-group">
                        <label className="acc-label2 mb-1">Agent Type*</label>
                        <select
                          value={this.state.type}
                          onChange={this.handleChange}
                          className="form-select acc-form form-select-lg col-lg-11"
                          name="type"
                        >
                          <option value="">Please Select</option>
                          {[]
                            .concat(agent_type)
                            .sort((a, b) => (a.title > b.title ? 1 : -1))
                            .map((head) => (
                              <option key={head.value} value={head.value}>
                                {head.title}
                              </option>
                            ))}
                        </select>
                        {this.state.typeError && (
                          <>
                            <small className="error">
                              {this.state.typeError}
                            </small>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 pl-lg-3 pt-1 pt-lg-1">
                      <div className="form-group">
                        <label className="acc-label2 mb-1">
                          Handling Manager
                        </label>
                        <select
                          value={this.state.manager}
                          className="form-select acc-form form-select-lg w-lg-90"
                          onChange={(e) =>
                            this.setState({ manager: e.target.value })
                          }
                          aria-label="Handling Manager"
                        >
                          <option value="" disabled>
                            Please Select
                          </option>
                          {this.state.userList.length > 0 ? (
                            this.state.userList.map((user) => (
                              <option key={user?.id} value={user?.id}>
                                {user?.name}
                              </option>
                            ))
                          ) : (
                            <option disabled>No users available</option>
                          )}
                        </select>
                        {this.state.managerError && (
                          <small className="error">
                            {this.state.managerError}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 pl-lg-3">
                      <div className="form-group">
                        <label className="acc-label2 mb-1">Email*</label>
                        <input
                          type="text"
                          name="email"
                          value={this.state.email}
                          className="form-control acc-form w-lg-90"
                          placeholder="Please Enter"
                          onChange={this.handleChange}
                        />
                        {this.state.emailError && (
                          <>
                            <small className="error">
                              {this.state.emailError}
                            </small>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group"></div>
                      <CustomPhoneInput
                        value={this.state.phone}
                        onChange={this.handlePhoneChange}
                        error={this.state.phoneError}
                        placeholder="Enter your phone number"
                        defaultCountry="AU"
                        required
                        label="Phone Number"
                      />
                    </div>
                    <div className="col-lg-8 pl-lg-3">
                      <div className="form-group">
                        <label className="acc-label2 mb-1">Description</label>
                        <textarea
                          className="textarea form-control acc-form"
                          name="description"
                          placeholder="Please Enter"
                          onChange={this.handleChange}
                          rows="4"
                          cols="60"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12 mb-3 mt-3 scroll">
                      <button
                        type="submit"
                        className="btn btn-success ml-2"
                        onClick={this.handleSubmit}
                      >
                        Create Agent
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          "You dont have permission to access this pages!"
        )}
      </>
    );
  }
}
export default withNavigation(AddAgent);
